import React from 'react';
import RegistrationForm from './RegistrationForm';

const RegistrationCard = () => {
  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-card border border-border rounded-lg shadow-soft-lg p-6 sm:p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-semibold text-foreground mb-2">
            Create Your Account
          </h1>
          <p className="text-muted-foreground text-sm">
            Join MycoMind to start tracking your neurological health and connect with healthcare providers
          </p>
        </div>

        {/* Registration Form */}
        <RegistrationForm />

        {/* Login Link */}
        <div className="mt-6 text-center">
          <p className="text-sm text-muted-foreground">
            Already have an account?{' '}
            <button
              onClick={() => window.location.href = '/login-screen'}
              className="text-primary hover:text-primary/80 font-medium transition-colors duration-150"
            >
              Sign in here
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationCard;